import { useTranslation, lang } from '@/helpers/translate';
import ByTags from '@/components/space/bytags.js';

export default function RootComponent({ similarSpacesDefault }) {
  const { t } = useTranslation();

  function getSimilarSpace() {
    return similarSpacesDefault;
  }
  return (
    <>
      {similarSpacesDefault?.length > 0
        ? (
          <section className="bg-was-cream pt-1 text-purple-5/50 flex-row">
            <div className="container mt-8 md:mt-10 mx-auto px-6 md:px-10 lg:px-10 xl:px-20 2xl:px-48 flex flex-col">
              <h2 className="pb-4 m-0 font-heading text-[14px] font-extrabold uppercase leading-[1.2] tracking-[0.02em] text-was-ink md:text-[15px]">{t('space:space_similar')}</h2>
              <ByTags spaces={getSimilarSpace()} />
            </div>
          </section>
        )
        : ' '}
    </>
  );
}
